export default {
	ACTION_UPGRADE: 1,
	ACTION_CONTACT: 2,
	ACTION_CANCEL: 3,
	ACTION_CONTINUE: 4,
	ACTION_SUBS_DASHBOARD: 5,
	ACTION_SKIP_ADMIN_ONBOARDING_STEP: 6,
	ACTION_AUTO_DISMISS: 7,
}
